import React, {useState,useEffect} from "react";
import { Spin,Tooltip } from "antd";
import Razorpay from "../../asserts/Razorpay2.png"
import dashes1 from "../../asserts/dashes1.png";
import dashes2 from "../../asserts/dashes2.png";
import total from "../../asserts/Total.png"
import refund from "../../asserts/Refund.png"
import settled from "../../asserts/Settled.png"
import pendingimg from "../../asserts/Pending.png"
import icon1 from "../../asserts/Sales Icon.png"
import icon2 from "../../asserts/Order Icon.png"
import icon3 from "../../asserts/Disc Icon.png"
import {YAxis,XAxis,LineChart, Line, CartesianGrid, ResponsiveContainer,PieChart,Pie,Cell,Sector,Tooltip as ReTooltip } from "recharts";
import "../../App.css";
import { useSelector, useDispatch } from "react-redux";
import { GetRazorpayDetails } from "../../Api/Payments/Payments";
import {capitalizeFirstLetter} from "../Common/Captilization"
import Payments from "./Payments";





export const RazorpayDashboard = ({dateClear,spinning,setSpinning,loader,setLoad}) => {
    const dispatch = useDispatch();
    const [activePicker,setActivePicker]=useState("Weekly")
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [activeIndexes] = useState([0, 1, 2]);
   console.log(hoveredIndex,"dfcewadfw")
    const getRazorpayDetails =
    useSelector((state) => state.crm.razorpay_details) || {};
    console.log(getRazorpayDetails, "detaildetails");
    const lineChartDetails = getRazorpayDetails.chartDetails || []
    const upi=getRazorpayDetails?.paymentBreakDown?.upi
    const card=getRazorpayDetails?.paymentBreakDown?.card
    const others=getRazorpayDetails?.paymentBreakDown?.others

      const DataPiePayment = [
    {
      name: "UPI",
      color: "#02CA70",
      value: upi,
    },
    {
      name:"Card",
      color: "#FFD700",
      value: card,
    },
    {
      name:"Others",
      color: "#3E7DFB",
      value: others,
    }
  ]


      const handleLineChartFilter = (value) => {
        console.log(value, "activeactive");
        if (value === "Weekly") {
            GetRazorpayDetails(dispatch,setSpinning,setLoad,"null","null",1);
          
        } else if (value === "Monthly") {
          
            GetRazorpayDetails(dispatch,setSpinning, setLoad, "null", "null", 2);
          
        } else if (value === "Yearly") {
    GetRazorpayDetails(dispatch,setSpinning, setLoad, "null", "null", 3);
      };
    }

const formatNumber = (value) => {
  if (value === undefined || value === null || isNaN(value)) {
    return "Invalid value";
  }

  // Million Format (example: 1.2M)
  if (value >= 1000000) {
    return (value / 1000000).toFixed(1) + "M";
  }

  // Thousand Format (example: 30.7K)
  if (value >= 1000) {
    return (value / 1000).toFixed(1) + "K";
  }

  // Below 1000, just return the number
  return value.toString();
};



const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div style={{
      backgroundColor: 'white',
      border: '1px solid #ccc',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px'
    }}>
      <p style={{ margin: 0, fontWeight:'bold' }}>{label}</p>

      {payload.map((item, index) => (
        <p key={index} style={{ display: 'flex', alignItems: 'center', margin: '4px 0' }}>
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: item.color,
              display: 'inline-block',
              marginRight: 6
            }}
          />
         {capitalizeFirstLetter(item.name)} : {item.value === 0 ? '0' : `${formatNumber(item.value)}`}
        </p>
      ))}
    </div>
  );
};




const COLORS = ["#02CA70",'#FFD700' , "#3E7DFB"];
const totalValue = upi + card + others;

  const hoveredName =
    hoveredIndex !== null ? DataPiePayment[hoveredIndex]?.name : null;
  const hoveredValue =
    hoveredIndex !== null ? DataPiePayment[hoveredIndex]?.value : totalValue;

  const labelTitle =
    hoveredName === "Others"
      ? "Other Payment"
      : hoveredName === "Card"
      ? "Card Payment"
      : hoveredName === "UPI"
      ? "UPI Payment"
      : "Total Count";



const renderCustomLabel = (props) => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
 
  } = props;

const RADIAN = Math.PI / 180;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const offset = 10;
// const labelX = cx + radius * cos;
// const labelY = cy + radius * sin;

  const percentage = (payload.value / (upi + card + others)) * 100;

    return (
      <g>
               <Sector
                  cx={cx}
                  cy={cy}
                  innerRadius={
                    hoveredIndex === payload.name ? innerRadius + 10 : innerRadius + 6
                  }
                  outerRadius={
                    hoveredIndex === payload.name ? outerRadius + 10 : outerRadius + 6
                  }
                  startAngle={startAngle}
                  endAngle={endAngle}
                  fill={fill}
                  className="transition-all duration-500 ease-in-out z-0 relative"
                />

         <text x={cx} y={cy} textAnchor="middle" pointerEvents="none">
          <tspan
            x={cx}
            dy="-1vw"
            fontSize="0.85vw"
            fontWeight="lighter"
            fill="#737373"
            pointerEvents="none"
          >
      
               {labelTitle}
          </tspan>
          <tspan
            x={cx}
            dy="40"
            fontWeight="bold"
            fontSize="1.75vw"
            fill="black"
            pointerEvents="none"
          >
            {hoveredValue}
          </tspan>
        </text>


        
{/* <foreignObject
  x={labelX - 25}
  y={labelY - 25}
  width={50}
  height={50}
  className="absolute"
>
  <div className="z-50">
    <div
      className={`bg-white text-[10px] text-center py-1 px-2 rounded-full  flex items-center justify-center w-[30px] h-[30px] leading-tight border-blue-700 border`}
    >
      <p className="whitespace-nowrap font-bold">
        {Math.round(percentage)}<span>%</span>
      </p>
    </div>
  </div>
</foreignObject> */}

      </g>
    );
  };


return (
  <>
    <div className="w-full h-[78.5vh] rounded-[1vw] bg-[#fff]  border-[#1f4b7f] border-t-[0.1vw] border-l-[0.1vw] border-r-[0.2vw] border-b-[0.2vw] relative p-[0.5vw] " >
      {spinning ? (
       <div>
          <div className="absolute top-[33vh] left-[45vw] flex justify-center items-center  z-10">
                              <Spin size="large" />
                            </div>
          <div className="absolute top-[43vh] left-[27vw] flex justify-center items-center  z-10 col-span-6 text-gray-500 font-bold text-[1.8vw]">
            Hold on, loading... Please don’t refresh or leave.
          </div>
        </div>
          
        ) : (
<div className="grid grid-cols-5 h-full p-[0.1vw]">
        <div className="col-span-1 h-[8vw] md:h-[11vw] lg:h-[8vw] w-[8vw]  ml-[1vw] relative">
            <img
      src={Razorpay}
      className="absolute w-full h-full"
      alt="razorpay"
    />
      </div>
      <div className="col-span-4 grid grid-cols-3 gap-x-4 -ml-[8vw] ">
<div className="bg-[#02CA70] col-span-1 rounded-[1.5vw] py-[0.5vw] px-[2vw] relative dash-container2 flex flex-col justify-center">
  {/* Title */}
  <p className="text-[1.8vw] text-white font-medium z-[10]">
    Total Collections
  </p>

  {/* Content Row */}
  <div className="flex justify-between items-start z-[10]">
    {/* Text Section */}
    <div className="text-white flex flex-col gap-[0.1vw]">
      <div className="text-[1.8vw] font-bold leading-tight">
        {getRazorpayDetails?.cardDetails?.totalCollection >= 1000 ? (
          <Tooltip
            placement="right"
            title={`₹ ${Number(getRazorpayDetails?.cardDetails?.totalCollection).toLocaleString("en-IN")}`}
            className="cursor-pointer"
            color="white"
            overlayInnerStyle={{
              color: "#1F487C",
              fontSize: "1vw",
            }}
          >
            <span>
              ₹ {formatNumber(Number(getRazorpayDetails?.cardDetails?.totalCollection).toFixed(2))}
            </span>
          </Tooltip>
        ) : (
          <span>
            ₹ {Number(getRazorpayDetails?.cardDetails?.totalCollection).toFixed(2)}
          </span>
        )}
      </div>
      <p className="underline text-[1vw]">
        View Entire List
      </p>
    </div>

    {/* Icon Section */}
    <div className="w-[4vw] h-auto">
      <img
        src={total}
        className="w-full h-auto object-contain"
        alt="Total Amount"
      />
    </div>
  </div>

  {/* Right-side white bars */}
  <div className="absolute right-0 top-[2vw] flex flex-col gap-[1.5vw]">
    {[...Array(3)].map((_, i) => (
      <div key={i} className="w-[1vw] h-[0.5vw] bg-white rounded-l-full" />
    ))}
  </div>

  {/* Background graphics */}
  
  <div className="absolute top-0 flex flex-col left-15">
    <img src={dashes1} alt="dash pattern" className="mt-[0.8vw] opacity-75 w-[15vw]" />
    <img src={dashes2} alt="dash pattern" className="ml-[3vw] -mt-[2vw] opacity-75 w-[15vw]" />
  </div>
</div>
{/* Refund Amount Card */}
<div className="bg-[#FF574B] col-span-1 rounded-[1.5vw] py-[0.5vw] px-[2vw] relative dash-container2 flex flex-col justify-center">
  <p className="text-[1.8vw] text-white font-medium z-[10]">Refund Amounts</p>

  <div className="flex justify-between items-start z-[10]">
    <div className="text-white flex flex-col gap-[0.1vw]">
      <div className="text-[1.8vw] font-bold leading-tight">
        {getRazorpayDetails?.cardDetails?.refundedAmount >= 1000 ? (
          <Tooltip
            placement="right"
            title={`₹ ${Number(getRazorpayDetails?.cardDetails?.refundedAmount).toLocaleString("en-IN")}`}
            className="cursor-pointer"
            color="white"
            overlayInnerStyle={{ color: "#1F487C", fontSize: "1vw" }}
          >
            <span>
              ₹ {formatNumber(Number(getRazorpayDetails?.cardDetails?.refundedAmount).toFixed(2))}
            </span>
          </Tooltip>
        ) : (
          <span>
            ₹ {Number(getRazorpayDetails?.cardDetails?.refundedAmount).toFixed(2)}
          </span>
        )}
      </div>
      <p className="underline text-[1vw] ">View Entire List</p>
    </div>

    <div className="w-[4vw] h-auto">
      <img src={refund} className="w-full h-auto object-contain" alt="Refunded" />
    </div>
  </div>

  {/* Decorative bars */}
  <div className="absolute right-0 top-[2vw] flex flex-col gap-[1.5vw]">
    {[...Array(3)].map((_, i) => (
      <div key={i} className="w-[1vw] h-[0.5vw] bg-white rounded-l-full" />
    ))}
  </div>
  <div className="absolute left-0 top-[2vw] flex flex-col gap-[1.5vw]">
    {[...Array(3)].map((_, i) => (
      <div key={i} className="w-[1vw] h-[0.5vw] bg-white rounded-r-full" />
    ))}
  </div>

  {/* Background graphics */}
  
  <div className="absolute top-0 flex flex-col left-15">
    <img src={dashes1} alt="dash pattern" className="mt-[0.8vw] opacity-75 w-[15vw]" />
    <img src={dashes2} alt="dash pattern" className="ml-[3vw] -mt-[2vw] opacity-75 w-[15vw]" />
  </div>
</div>


{/* Settled to Bank Card */}
<div className="bg-[#3E7DFB] col-span-1 rounded-[1.5vw] py-[0.5vw] px-[2vw] relative dash-container2 flex flex-col justify-center">
  <p className="text-[1.8vw] text-white font-medium z-[10]">Settled to Bank</p>

  <div className="flex justify-between items-start z-[10]">
    <div className="text-white flex flex-col gap-[0.1vw]">
      <div className="text-[1.8vw] font-bold leading-tight">
        {getRazorpayDetails?.cardDetails?.settledToBank >= 1000 ? (
          <Tooltip
            placement="right"
            title={`₹ ${Number(getRazorpayDetails?.cardDetails?.settledToBank).toLocaleString("en-IN")}`}
            className="cursor-pointer"
            color="white"
            overlayInnerStyle={{ color: "#1F487C", fontSize: "1vw" }}
          >
            <span>
              ₹ {formatNumber(Number(getRazorpayDetails?.cardDetails?.settledToBank).toFixed(2))}
            </span>
          </Tooltip>
        ) : (
          <span>
            ₹ {Number(getRazorpayDetails?.cardDetails?.settledToBank).toFixed(2)}
          </span>
        )}
      </div>
      <p className="underline text-[1vw] ">View Entire List</p>
    </div>

    <div className="w-[4vw] h-auto">
      <img src={settled} className="w-full h-auto object-contain" alt="Settlement" />
    </div>
  </div>

  {/* <div className="absolute right-0 top-[1.5vw] flex flex-col gap-[1.5vw]">
    {[...Array(3)].map((_, i) => (
      <div key={i} className="w-[1vw] h-[0.5vw] bg-white rounded-l-full" />
    ))}
  </div> */}
  <div className="absolute left-0 top-[2vw] flex flex-col gap-[1.5vw]">
    {[...Array(3)].map((_, i) => (
      <div key={i} className="w-[1vw] h-[0.5vw] bg-white rounded-r-full" />
    ))}
  </div>

  <div className="absolute top-0 flex flex-col left-13.5">
    <img src={dashes1} alt="dash pattern" className="mt-[0.8vw] opacity-75 w-[15vw]" />
    <img src={dashes2} alt="dash pattern" className="ml-[3vw] -mt-[2vw] opacity-75 w-[15vw]" />
  </div>
</div>


{/* Pending Settlement Card */}
{/* <div className="bg-yellow-400 col-span-1 rounded-[1.5vw] px-[2vw] pt-[0.8vw]  relative flex flex-col gap-[0.5vw]">
  <p className="text-[1.6vw] text-white font-medium">Pending Settlement</p>

  <div className="flex justify-between items-start">
    <div className="text-white flex flex-col gap-[0.1vw]">
      <div className="text-[1.8vw] font-bold leading-tight">
        {getRazorpayDetails?.cardDetails?.settledToBank >= 1000 ? (
          <Tooltip
            placement="right"
            title={`₹ ${Number(getRazorpayDetails?.cardDetails?.settledToBank).toLocaleString("en-IN")}`}
            className="cursor-pointer"
            color="white"
            overlayInnerStyle={{ color: "#1F487C", fontSize: "1vw" }}
          >
            <span>
              ₹ {formatNumber(Number(getRazorpayDetails?.cardDetails?.settledToBank).toFixed(2))}
            </span>
          </Tooltip>
        ) : (
          <span>
            ₹ {Number(getRazorpayDetails?.cardDetails?.settledToBank).toFixed(2)}
          </span>
        )}
      </div>
      <p className="underline text-[1vw] cursor-pointer">View Entire List</p>
    </div>

    <div className="w-[4vw] h-auto">
      <img src={pendingimg} className="w-full h-auto object-contain" alt="Pending" />
    </div>
  </div>

  <div className="absolute left-0 top-[1.5vw] flex flex-col gap-[1.5vw]">
    {[...Array(3)].map((_, i) => (
      <div key={i} className="w-[1vw] h-[0.5vw] bg-white rounded-r-full" />
    ))}
  </div>

  <div className="absolute top-0 z-0">
    <img src={dashes1} alt="dash pattern" className="mt-[0.5vw] opacity-75 w-[14vw]" />
    <img src={dashes2} alt="dash pattern" className="ml-[3vw] -mt-[2vw] opacity-75 w-[14vw]" />
  </div>
</div> */}

</div>
<div className="col-span-5 grid grid-cols-4 grid-rows-1 pt-[0.5vw]">
      <div className="row-span-1 col-span-3 grid grid-rows-3">
        <div className="row-span-2 col-span-4 bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] px-[1vw] flex flex-col shadow-lg pt-[0.7vw] ">
    <div className="flex justify-between items-center mb-[0.5vw]">
      <div className="flex flex-col gap-[0.25vw] leading-tight">
        <p className="text-[1vw] text-[#737373]">Total</p>
        <span className="font-bold text-[1.1vw] text-[#0A0A0A]">Performance</span>
      </div>
      <div className="flex items-center gap-[0.5vw]">
        <div className="flex gap-[1vw] text-[0.85vw] mr-[2vw]">
          {[
            { color: "#02CA70", label: "Collected Amount" },
            { color: "#FF574B", label: "Refunds" },
            { color: "#3E7DFB", label: "Settled Amount" },
          ].map(({ color, label }) => (
            <div
              key={label}
              className="border border-[#1F4B7F80] flex items-center gap-[0.25vw] px-[0.5vw] py-[0.1vw] rounded-[0.5vw]"
            >
              <div
                className="rounded-full w-[0.5vw] h-[0.5vw]"
                style={{ backgroundColor: color }}
              />
              <p>{label}</p>
            </div>
          ))}
        </div>
        <div
          className={`flex items-center bg-[#1F4B7F80] p-[0.25vw] rounded-[0.75vw] w-[14.75vw] ${
            dateClear ? "cursor-not-allowed" : ""
          }`}
        >
          {["Weekly", "Monthly", "Yearly"].map((type) => (
            <button
              key={type}
              onClick={() => {
                if(activePicker==="Weekly"){
                  setLoad(false)
                }else{
                  setLoad(true);
                }
                if (activePicker !== type) {
                  setActivePicker(type);
                }
                handleLineChartFilter(type);
              }}
              className={`px-[1vw] py-[0.25vw] rounded-[0.5vw] text-[0.85vw] capitalize ${
                activePicker === type && !dateClear
                  ? "bg-white text-[#1F487C] font-bold"
                  : "text-white"
              } ${dateClear ? "pointer-events-none" : ""}`}
            >
              {type}
            </button>
          ))}
        </div>
      </div>
    </div>
        <div style={{ width: '100%', height: '28vh' }}>
          {loader ? (
        <div className="absolute inset-0 top-[48%] left-[37%] z-10 left-50% " >
          <Spin size="large" />
        </div>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={lineChartDetails} layout="horizontal">
            <CartesianGrid horizontal={true} vertical={false} />
            <XAxis dataKey="name" padding={{ left: 30, right: 0 }} />
            <YAxis
              tickFormatter={(value) =>
                value === 0 ? "0" : `${value / 1000}k`
              }
            />
            <ReTooltip content={<CustomTooltip />} />
            <Line
              dataKey="payment"
              stroke="#02CA70"
              strokeWidth={2}
              dot={{ stroke: "none", fill: "#02CA70" }}
            />
            <Line
              dataKey="refund"
              stroke="#FF574B"
              strokeWidth={2}
              dot={{ stroke: "none", fill: "#FF574B" }}
            />
            <Line
              dataKey="settlement"
              stroke="#3E7DFB"
              strokeWidth={2}
              dot={{ stroke: "none", fill: "#3E7DFB" }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
          </div>

    </div>
  
    <div className="row-span-1 col-span-4 grid grid-cols-4 gap-x-4 pt-[0.5vw]">
      <div className="bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] col-span-1 dash-container2 grid grid-cols-7 ">
                  <div className="col-span-2 bg-[#4848484D] border-r-[0.2vw] border-r-[#535353] rounded-l-[1.5vw] flex justify-center items-center">
                    <img
                      src={icon1}
                      alt="base fare icon"
                      className="bg-[#535353] p-[0.5vw] rounded-full"
                    />
                  </div>
                  <div className="col-span-5 pr-[1vw] py-[1vw] pl-[0.5vw] flex flex-col justify-center">
                    <p className="text-[1vw] flex items-start justify-start gap-[0.25vw] text-[#737373]">
                      Razorpay Fee
                    </p>
                    <span className="font-bold text-[1.1vw] text-[#0A0A0A] flex items-start justify-start gap-[0.25vw]">
                        Paid
                      </span>

                    <div className="flex justify-start">
                      

                      <p className="text-[2vw] font-bold">
                 20K
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] col-span-1 dash-container2 grid grid-cols-7">
                  <div className="col-span-2 bg-[#02CA704D] border-r-[0.2vw]  border-r-[#02CA70] rounded-l-[1.5vw] flex justify-center items-center">
                    <img
                      src={icon1}
                      alt="tbs fare icon"
                      className="bg-[#02CA70] p-[0.5vw] rounded-full"
                    />
                  </div>
                  <div className="col-span-5 pr-[1vw] py-[1vw] pl-[0.5vw] flex flex-col justify-center">
                    <p className="text-[1vw] flex items-start justify-start gap-[0.25vw] text-[#737373]">
                      Net Revenue
                    </p>
                     <span className="font-bold text-[1.1vw] text-[#0A0A0A] flex items-start justify-start gap-[0.25vw]">
                        After Fees
                      </span>

                    <div className="flex justify-start">
                     

                      <p className="text-[2vw] font-bold text-[#02CA70]">
               20K
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] col-span-1 dash-container2 grid grid-cols-7">
                  <div className="col-span-2 bg-[#4848484D] border-r-[0.2vw] border-r-[#535353] rounded-l-[1.5vw] flex justify-center items-center">
                    <img
                      src={icon2}
                      alt="gst icon"
                      className="bg-[#535353] px-[0.65vw] py-[0.6vw] rounded-full"
                    />
                  </div>
                  <div className="col-span-5 pr-[0.5vw] py-[1vw] pl-[0.5vw] flex flex-col justify-center">
                    <p className="text-[1vw] flex items-start justify-start gap-[0.25vw] text-[#737373]">
                      Chargeback / Dispute
                    </p>
                    <span className="font-bold text-[1.1vw] flex items-start justify-start gap-[0.25vw] text-[#0A0A0A]">
                        Values
                      </span>

                    <div className="flex justify-start">
                      

                      <p className="text-[2vw] font-bold">
                    20K
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] col-span-1 dash-container2 grid grid-cols-7">
                  <div className="col-span-2 bg-[#02CA704D] border-r-[0.2vw] border-r-[#02CA70] rounded-l-[1.5vw] flex justify-center items-center">
                    <img
                      src={icon3}
                      alt="offer icon"
                      className="bg-[#02CA70] px-[0.65vw] py-[0.6vw] rounded-full"
                    />
                  </div>
                  <div className="col-span-5 pl-[0.5vw] pr-[1vw] py-[1vw] flex flex-col justify-center">
                    <p className="text-[1vw] flex items-start justify-start gap-[0.25vw] text-[#737373]">
                      Average Settlement 
                    </p>
                    <span className="font-bold text-[1.1vw] flex items-start justify-start gap-[0.25vw] text-[#0A0A0A] ">
                        Time
                      </span>

                    <div className="flex justify-start">
                      

                      <p className="text-[2vw] font-bold text-[#02CA70]">
                      
                            20K
                          
                        
                      </p>
                    </div>
                  </div>
                  
    


    </div>
      </div>
        </div>
    <div className=" col-span-1 row-span-1 bg-gradient-to-b from-[#A9F9EE] to-[#F9FFF1] rounded-[1.5vw] shadow-lg p-[1vw] ml-[0.5vw] relative">
      <div className="flex flex-col gap-[0.25vw] leading-tight">
        <p className="text-[1vw] text-[#737373]">Payment</p>
        <span className="font-bold text-[1.1vw] text-[#0A0A0A]">Breakdown</span>
      </div>
      <div className="mt-[0.25vw] relative">
        <div className="grid grid-cols-3 text-[0.85vw] mt-[1.5vw]">
          <p className="col-span-2">Label</p>
          <p className="col-span-1 justify-self-end">Count</p>
        </div>

        <hr className="mb-[1vw] border-[0.1vw] border-[#1F4B7F80]" />

        <div className="grid grid-cols-2 gap-y-[0.75vw] text-[0.85vw]">
          <div className="flex flex-col gap-[0.75vw]">
            <div className="flex items-center gap-[0.25vw]">
              <div className="bg-[#02CA70] rounded-full w-[0.5vw] h-[0.5vw]" />
              <span>UPI Payment</span>
            </div>
            <div className="flex items-center gap-[0.25vw]">
              <div className="bg-yellow-400 rounded-full w-[0.5vw] h-[0.5vw]" />
              <span>Cards Payment</span>
            </div>
            <div className="flex items-center gap-[0.25vw]">
              <div className="bg-[#3E7DFB] rounded-full w-[0.5vw] h-[0.5vw]" />
              <span>Others Payment</span>
            </div>
          </div>

          <div className="flex flex-col gap-[0.75vw] justify-self-end text-right">
            {DataPiePayment?.map((pass, index) => (
              <p key={index}>{pass.value}</p>
            ))}
          </div>
        </div>
      </div>
      <div className= "mt-[0.5vw] w-full h-full absolute top-[4vw]  left-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={DataPiePayment}
              cx="55%"
              cy="56%"
              innerRadius="28%"
              outerRadius="43%"
              paddingAngle={2}
              dataKey="value"
              stroke="none"
              activeShape={renderCustomLabel}
               activeIndex={[...activeIndexes, hoveredIndex]} 
              labelLine={false}
               onMouseEnter={(_, index) => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            >
              {DataPiePayment.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  </div>

</div>      
          
        )}
          
        

    </div>  
    
  </>
)
}
